<template>
  <b-row class="mx-0 margin-bottom-22">
    <b-col
      cols="12"
      md="12"
      class="flex-between otp font-size-12 color-complementary-300 margin-bottom-8 px-0"
    >
      <span>کد ارسال شده به شماره {{ MOBILE }} را وارد نمایید</span>
      <span v-if="showEdit" class="cursor--pointer" @click="editNumber"
        ><mdicon name="pencil-outline" size="20"
      /></span>
    </b-col>
    <b-col
      cols="12"
      md="12"
      class="d-flex align-items-center justify-content-between px-0 otp"
    >
      <div class="otp__input">
        <OtpInput
          :input-classes="`input ${
            generateState === false ? 'is-invalid' : ''
          }`"
          :separator="separator"
          :num-inputs="numInputs"
          :should-auto-focus="autofocus"
          :is-input-num="true"
          @on-change="handleOnChange"
          @on-complete="handleOnComplete"
        />
      </div>
      <b-button
        class="otp__button"
        :disabled="!!counter"
        @click="!counter && resend()"
      >
        <div v-if="counter" class="otp__counter">
          <span v-text="counter" />
          <mdicon v-if="counter" name="timer-outline" size="24" />
        </div>
        <span v-else v-text="$lang.resend" />
      </b-button>
    </b-col>
    <b-col cols="12" md="12" class="px-0">
      <FeedbackMessages
        :state="generateState"
        :label="label"
        :vuelidateObj="vuelidateObj"
      />
    </b-col>
  </b-row>
</template>
<script>
import OtpInput from "@bachdgvn/vue-otp-input";
import { FeedbackMessages } from "@/components/re-design/forms";
import { pathOr } from "ramda";

export default {
  inject: ["MOBILE"],
  components: {
    OtpInput,
    FeedbackMessages,
  },
  props: {
    value: {}, // watch model
    name: {
      // key for update value
      type: String,
      default: null,
    },
    label: {
      // input label
      type: String,
      default: "کد پیامـک شده",
    },
    id: {
      // input id
      type: String,
      default: "default-id",
    },
    numInputs: {
      // num input
      type: Number,
      default: +process.env.VUE_APP_OTP_CODE_LENGTH || 4,
    },
    autofocus: {
      // auto focus input
      type: Boolean,
      default: true,
    },
    separator: {
      // separator inputs
      type: String,
      default: "",
    },
    vuelidateObj: {
      // vuelidate object of input
      type: Object,
      default: null,
    },
    expireSeconds: {
      // expire time by seconds
      type: [Number, String],
      default: 300,
    },
    showEdit: {
      // show edit button
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      timerQueue: null,
      counter: null,
      controlCode: null,
      clientStartedTime: null,
    };
  },
  computed: {
    inputValue: {
      /* guidance: watching input value */
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", this.name, val);
      },
    },
    generateState() {
      return this.vuelidateObj.$dirty ? !this.vuelidateObj.$error : null;
    },
  },
  watch: {
    expireTime: {
      immediate: true,
      handler(value) {
        // started time
        this.clientStartedTime = new Date();
        this.timer(value);
      },
    },
  },
  destroyed() {
    clearInterval(this.timerQueue);
  },
  methods: {
    pathOr,
    handleOnChange(value) {
      this.inputValue = value;
    },
    handleOnComplete(value) {
      this.$emit("onComplete", value);
    },
    reset() {
      this.counter = null;
      this.handleOnChange(null);
      clearInterval(this.timerQueue);
    },
    timer(expireSeconds = 300) {
      let distance = expireSeconds;
      clearInterval(this.timerQueue);
      this.timerQueue = setInterval(() => {
        // check different started time with now time
        const startedTime = new Date(this.clientStartedTime).getTime();
        const nowTime = new Date().getTime();
        const differentTimeSeconds = Math.round((nowTime - startedTime) / 1000);
        distance = expireSeconds - differentTimeSeconds;

        distance -= 1;
        let minutes = Math.floor((distance % (60 * 60)) / 60);
        let seconds = Math.floor((distance % 60) / 1);
        minutes = minutes > 0 ? minutes : 0;
        minutes = minutes >= 10 ? minutes : `0${minutes}`;
        seconds = seconds >= 10 ? seconds : `0${seconds}`;
        this.counter = minutes + ":" + seconds;
        if (distance < 0) {
          this.reset();
        }
      }, 1000);
    },
    resend() {
      this.$emit("resend", () => {
        this.timer();
      });
    },
    editNumber() {
      this.$emit("editNumber");
    },
  },
};
</script>
